import React from "react";
import { PurchasedList } from "../../components/PurchasedList";
import {
  BannerWrap,
  FlexList,
  ListItem,
  MainBanner,
  TopWrap,
  PointLabel,
  PointImg,
  PointTitle,
  PointDescription,
  PointAttention,
} from "./elements";
import { PurchaseFlow } from "../../components/PurchaseFlow";
import Banner1 from "../../assets/images/banner1.png";
import Banner3 from "../../assets/images/banner3.png";
import LowCost from "../../assets/images/low_cost.png";
import SmartphoneMan from "../../assets/images/smartphone_man.png";
import Track from "../../assets/images/track.png";
import { Section } from "../../components/Section";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper";

export const TopPage: React.FC = React.memo(() => {
  return (
    <TopWrap>
      <BannerWrap>
        <Swiper
          className="sample-slider"
          modules={[Autoplay]}
          loop={true}
          autoplay={{ delay: 2800 }}
        >
          <SwiperSlide>
            <MainBanner src={Banner1} />
          </SwiperSlide>
          <SwiperSlide>
            <MainBanner src={Banner3} />
          </SwiperSlide>
        </Swiper>
      </BannerWrap>
      <Section title="買取BestValueのここが凄い">
        <FlexList>
          <ListItem>
            <PointLabel>Point 1</PointLabel>
            <PointImg src={LowCost} />
            <PointTitle>無駄なコスト削減!!</PointTitle>
            <PointDescription>
              オンラインのみの為店舗経費なし、
              <br />
              人員最低限の為利益最小限で買取可能。
            </PointDescription>
          </ListItem>
          <ListItem>
            <PointLabel>Point 2</PointLabel>
            <PointImg src={SmartphoneMan} />
            <PointTitle>減額無し!!</PointTitle>
            <PointDescription>分割金支払い中でも減額なし。</PointDescription>
            <PointAttention>※赤ロム、ジャンク品は買取不可。</PointAttention>
          </ListItem>
          <ListItem>
            <PointLabel>Point 3</PointLabel>
            <PointImg src={Track} />
            <PointTitle>配送費用全額負担!!</PointTitle>
            <PointDescription>
              郵送費用すべて弊社負担。
              <br />
              査定キャンセルの場合返送料も全額弊社負担。
            </PointDescription>
          </ListItem>
        </FlexList>
      </Section>
      <PurchasedList />
      <PurchaseFlow />
    </TopWrap>
  );
});

TopPage.displayName = "TopPage";
